<template>
  <div class="line"></div>
</template>

<script>
export default {
  name: "Line"
};
</script>

<style scoped>
.line {
  width: 160px;
  height: 1px;
  background: #CCCCCC;
  margin: 12px;

}
</style>
